var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-text-field", {
        ref: "fileTextField",
        attrs: {
          "prepend-icon": "attach_file",
          "single-line": "",
          label: _vm.label.toUpperCase(),
          required: _vm.required,
          disabled: _vm.disabled
        },
        nativeOn: {
          click: function($event) {
            return _vm.onFocus.apply(null, arguments)
          }
        },
        model: {
          value: _vm.filename,
          callback: function($$v) {
            _vm.filename = $$v
          },
          expression: "filename"
        }
      }),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        attrs: {
          type: "file",
          accept: _vm.accept,
          multiple: _vm.multiple,
          disabled: _vm.disabled
        },
        on: { change: _vm.onFileChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-138fef43", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-138fef43","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadButton.vue
// module id = null
// module chunks = 